import Helper from './Helper';

class ScrollToTop {
  constructor(config = {}) {
    const {
      buttonSelector
    } = config;
    this.buttons = document.querySelectorAll(buttonSelector);
    this.buttonsArray = Array.prototype.slice.call(this.buttons);
    if(this.buttons.length > 0){
      this.bindEvents();
    }
  }

  bindEvents(){
    this.buttonsArray.forEach((button, i) => {
      button.addEventListener('click', (e) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
  }

}

export default ScrollToTop;
